import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import classNames from "classnames";

export const SEASON_16_APP_BANNER_CTA = "season-16-app-cta";
interface Season16BannerProps {
  url: string;
  className?: string;
  onClick: (url: string) => void;
  onClose?: () => void;
  utmSource?: string;
}

export function Season16Banner(props: Season16BannerProps) {
  const { url, onClick, onClose, className, utmSource } = props;
  const href = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(href);
  };

  return (
    <div
      className={classNames(
        "w-full h-[48px] bg-[#FFF] flex justify-start relative overflow-hidden border-b border-b-[#1E3246]",
        className,
      )}
    >
      <div className="flex w-full h-48 bg-white">
        <img
          src="https://static.bigbrain.gg/assets/ugg/cta/season-16-banner-vector.png"
          className="flex h-[48px] shrink-0 max-w-none"
        ></img>
        <img
          src="https://static.bigbrain.gg/assets/ugg/cta/season-16-banner-vector.png"
          className="flex h-[48px] shrink-0 max-w-none"
        ></img>
        <img
          src="https://static.bigbrain.gg/assets/ugg/cta/season-16-banner-vector.png"
          className="flex h-[48px] shrink-0 max-w-none"
        ></img>
        <div className="absolute inset-0 max-[699px]:bg-white min-[700px]:bg-[linear-gradient(to_right,transparent_0%,transparent_calc(25%-5%),white_calc(25%+5%),white_100%)]"></div>
      </div>
      <img
        src="https://static.bigbrain.gg/assets/ugg/cta/season-16-banner-yasuo.png"
        className="absolute max-w-none top-0 h-[48px] shrink-0 right-[-277px] min-[475px]:right-[-200px] sm:right-[-140px] md:right-[-56px] lg:right-[18px]"
      ></img>
      <div
        className={classNames(
          "absolute inset-0 z-10 flex items-center justify-center xxs:justify-start min-[700px]:justify-center gap-[22px] xs:gap-[34px] sm:gap-[42.5px] px-3 sm:px-6 md:px-8 text-white",
          { "pr-10": onClose },
        )}
      >
        <div className="flex items-center gap-3">
          <div className="flex flex-col">
            <div className="relative -top-0.5 uppercase text-[18px] leading-[18px] text-center xs:text-left whitespace-nowrap text-[#11112A] font-['Barlow_Condensed'] font-bold leading-normal">
              <span className="hidden xxxs:inline xxxs:text-[16px]">LOL SEASON 16 IS LIVE</span>
            </div>
            <div className="font-inter font-medium text-[12px] leading-[12px] hidden xs:block text-center sm:text-left text-[#5C5C8E]">
              We've got all the new changes covered
            </div>
          </div>
        </div>
        <div
          className="bg-[#3273FA] hover:bg-[#2963DA] rounded-[3px] cursor-pointer p-2 sm:px-3 sm:py-2 flex items-center"
          onClick={onUrlClick}
        >
          <div className="hidden xs:inline text-[12px] sm:text-[13px] font-bold whitespace-nowrap">Check out the U.GG App</div>
          <div className="inline xs:hidden text-[12px] sm:text-[13px] font-bold whitespace-nowrap">Check out the App</div>
        </div>
      </div>

      {onClose && (
        <div
          className="absolute z-20 top-1/2 right-[12px] -translate-y-1/2 p-[6px] cursor-pointer hover:opacity-50"
          onClick={onClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="text-black drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.40)]" />
        </div>
      )}
    </div>
  );
}
